/**
 * ═══════════════════════════════════════════════════════════════
 * Hasımoğlu Çiftliği – Yetkisiz Erişim Sayfası
 * ═══════════════════════════════════════════════════════════════
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldX, ArrowLeft } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export default function UnauthorizedPage() {
  const navigate = useNavigate();
  const { logout } = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-navy-950">
      <div className="text-center max-w-md">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-danger-500/10 border border-danger-500/20 mb-6">
          <ShieldX className="w-10 h-10 text-danger-500" />
        </div>
        <h1 className="text-2xl font-bold text-white mb-2">Erişim Engellendi</h1>
        <p className="text-navy-400 mb-8">
          Bu sayfaya erişim yetkiniz bulunmamaktadır.
          Yetkili bir hesap ile giriş yapmanız gerekmektedir. Veya hesabınız askıya alınmış olabilir.
        </p>
        <div className="flex items-center justify-center gap-4">
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl font-medium text-white bg-gradient-to-r from-navy-600 to-navy-700 hover:from-navy-500 hover:to-navy-600 transition-all duration-200"
          >
            <ArrowLeft className="w-4 h-4" />
            Geri Dön
          </button>
          
          <button
            onClick={async () => {
              try {
                await logout();
                navigate('/login', { replace: true });
              } catch (err) {
                console.error(err);
              }
            }}
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl font-medium text-danger-500 bg-danger-500/10 hover:bg-danger-500/20 transition-all duration-200"
          >
            Sistemden Çıkış Yap
          </button>
        </div>
      </div>
    </div>
  );
}
